<template>
  <div>
    <header-top></header-top>
    <div class="advertisement" :class="{en:language!=='zh'}">
      <div class="advertisementBox">
        <p class="title">{{$t('business.广告刊例')}}</p>
        <div class="weChatBox">
          <p class="title_1">
            {{$t('business.微信公众号')}}：
            <span>{{$t('business.新媒体艺术站')}}</span>
          </p>
          <p class="title_2">
            <i>*</i> {{$t('business.内容需经过审核，至少提前两周预约排期')}}
          </p>
          <div class="tabBox">
            <div class="tabNav clearfix">
              <span class="text1">{{$t('business.服务类型')}}</span>
              <span class="text2">{{$t('business.广告形式')}}</span>
              <span class="text3">{{$t('business.发布时长')}}</span>
              <span class="text4">{{$t('business.备注')}}</span>
            </div>
            <div class="navTitle clearfix">
              <div class="navTitle1">
                <p class="title_text">{{$t('business.内容采编')}}</p>
                <p class="title_text">{{$t('business.头条发布')}}</p>
                <p class="title_text">{{$t('business.次条发布')}}</p>
                <p class="title_text">{{$t('business.头条文末链接')}}</p>
              </div>
              <div class="navTitle2">
                <p class="title_text">{{$t('business.软文')}}</p>
                <p class="title_text">{{$t('business.软文')}}</p>
                <p class="title_text">{{$t('business.软文')}}</p>
                <p class="title_text">{{$t('business.图文链接')}}</p>
              </div>
              <div class="navTitle3">
                <p class="title_text">{{$t('business.1次')}}</p>
                <p class="title_text">{{$t('business.1次')}}</p>
                <p class="title_text">{{$t('business.1次')}}</p>
                <p class="title_text">{{$t('business.1周')}}</p>
              </div>
              <div class="navTitle4">
                <p class="title_text1">
                  {{$t('business.需提供素材')}}：
                  {{$t('business.文字介绍、相关视频、动图或图片、涉及到的艺术家或团队介绍、赠票或衍生品服务（粉丝福利）')}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="appBox">
          <p class="title1">{{$t('business.网站和APP')}}</p>
          <p class="title2">
            <i>*</i> {{$t('business.内容需经过审核')}}
          </p>
          <div class="tabBox">
            <div class="tabNav clearfix">
              <span class="text1">{{$t('business.服务类型')}}</span>
              <span class="text2">{{$t('business.发布时长')}}</span>
              <span class="text3">{{$t('business.备注')}}</span>
            </div>
            <div class="navTitle clearfix">
              <div class="navTitle1">
                <p class="title_text">
                  <span class="span1">{{$t('business.网站+APP首页')}}</span>{{$t('business.Banner第二、三帧（见下图A1）')}}
                </p>
                <p class="title_text">
                  <span class="span2">{{$t('business.网站首页')}}</span>{{$t('business.频道推荐第二位（见下图A2）')}}
                </p>
                <p class="title_text">
                  <span class="span2">{{$t('business.网站首页')}}</span>{{$t('business.活动推荐第二位（见下图A3）')}}
                </p>
                <p class="title_text">
                  <span class="span2">{{$t('business.网站首页')}}</span>{{$t('business.优秀创作者第二位（见下图A4）')}}
                </p>
              </div>
              <div class="navTitle2">
                <p class="title_text">{{$t('business.1周')}}</p>
                <p class="title_text">{{$t('business.1周')}}</p>
                <p class="title_text">{{$t('business.1周')}}</p>
                <p class="title_text">{{$t('business.1周')}}</p>
              </div>
              <div class="navTitle3">
                <p class="title_text1">{{$t('business.需提供素材')}}：</p>
                <p class="title_text2">{{$t('business.大于2M的图片素材（请确认已授权）、文字内容')}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="positionBox">
          <p class="title1">{{$t('business.位置示意')}}</p>
          <div class="box clearfix">
            <img class="indicationImg1" src="https://image.manamana.net/web_sample.png" alt="">
            <img class="indicationImg2" src="https://image.manamana.net/app_sample.png" alt="">
          </div>
        </div>
        <div class="phoneBox">
          <p class="title1">{{$t('business.联系方式')}}</p>
          <p class="title2">{{$t('business.了解更多信息请联系人工客服')}}</p>
          <p class="title2">{{$t('business.服务热线')}}：021-52998050</p>
          <a class="title3" href="mailto:business@manamana.net">{{$t('business.商务合作邮箱')}}：business@manamana.net</a>
          <p class="title4">{{$t('business.workTime')}}</p>
        </div>
        <div class="buttomBox">
          <a href="https://manabang.mikecrm.com/iVUslu2" target="_blank">{{$t('business.预约服务')}}</a>
        </div>
      </div>
    </div>
    <footer-down class="searchFooter"></footer-down>
  </div>
</template>

<script>
import HeaderTop from "@/components/v2/Header.vue";
import FooterDown from "@/components/v2/Footer.vue";

export default {
  name: "advertisement",
  metaInfo() {
    return {
      title: this.$t("business.广告刊例") + " | MANA",
    };
  },
  components: {
    HeaderTop,
    FooterDown,
  },
  data() {
    return {};
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  watch: {
    $route(to, from) {},
  },
};
</script>

<style lang="stylus" scoped>
.searchFooter {
  position: relative !important;
}

.advertisement {
  background: #fff;
  padding: 70px 0 120px 0;

  .advertisementBox {
    width: 1110px;
    margin: 0 auto;

    .title {
      font-size: 44px;
      font-weight: 600;
      color: #0A0A0A;
    }

    .weChatBox {
      margin: 60px 0 100px 0;

      .title_1 {
        font-size: 24px;
        font-weight: 600;
        color: #0A0A0A;

        span {
          font-weight: 400;
        }
      }

      .title_2 {
        font-size: 14px;
        font-weight: 400;
        color: #667090;
        margin: 16px 0 36px 0;

        i {
          color: #FE5630;
        }
      }

      .tabBox {
        width: 1110px;
        height: 350px;
        border: 1px solid #EBEBEB;
        box-sizing: border-box;

        .tabNav {
          width: 100%;
          height: 46px;
          background: #F5F5F5;

          span {
            float: left;
            height: 46px;
            line-height: 46px;
            text-align: center;
            font-size: 16px;
            font-weight: 600;
            color: #666666;
          }

          span.text1 {
            width: 280px;
            border-right: 1px solid #EBEBEB;
            box-sizing: border-box;
          }

          span.text2 {
            width: 190px;
            border-right: 1px solid #EBEBEB;
            box-sizing: border-box;
          }

          span.text3 {
            width: 190px;
            border-right: 1px solid #EBEBEB;
            box-sizing: border-box;
          }

          span.text4 {
            width: 447px;
          }
        }

        .navTitle {
          width: 100%;

          .navTitle1 {
            float: left;
            width: 280px;

            .title_text {
              border-right: 1px solid #EBEBEB;
              border-bottom: 1px solid #EBEBEB;

              &:nth-child(4) {
                border-bottom: none;
              }
            }
          }

          .navTitle2 {
            float: left;
            width: 190px;

            .title_text {
              border-right: 1px solid #EBEBEB;
              border-bottom: 1px solid #EBEBEB;

              &:nth-child(4) {
                border-bottom: none;
              }
            }
          }

          .navTitle3 {
            float: left;
            width: 190px;

            .title_text {
              border-right: 1px solid #EBEBEB;
              border-bottom: 1px solid #EBEBEB;

              &:nth-child(4) {
                border-bottom: none;
              }
            }
          }

          .navTitle4 {
            float: left;
            width: 447px;
            padding: 0 37px;
            box-sizing: border-box;

            .title_text1 {
              font-size: 16px;
              font-weight: 400;
              color: #666666;
              line-height: 28px;
              margin-top: 80px;
            }
          }

          .title_text {
            font-size: 16px;
            font-weight: 400;
            color: #666666;
            height: 75px;
            line-height: 75px;
            text-align: center;
            box-sizing: border-box;
          }
        }
      }
    }

    .appBox {
      .title1 {
        font-size: 24px;
        font-weight: 600;
        color: #0A0A0A;
      }

      .title2 {
        font-size: 14px;
        font-weight: 400;
        color: #667090;
        margin: 16px 0 36px 0;

        i {
          color: #FE5630;
        }
      }

      .tabBox {
        width: 1110px;
        height: 350px;
        border: 1px solid #EBEBEB;
        box-sizing: border-box;

        .tabNav {
          width: 100%;
          height: 46px;
          background: #F5F5F5;

          span {
            float: left;
            height: 46px;
            line-height: 46px;
            text-align: center;
            font-size: 16px;
            font-weight: 600;
            color: #666666;
          }

          span.text1 {
            width: 470px;
            border-right: 1px solid #EBEBEB;
            box-sizing: border-box;
          }

          span.text2 {
            width: 180px;
            border-right: 1px solid #EBEBEB;
            box-sizing: border-box;
          }

          span.text3 {
            width: 457px;
            // border-right: 1px solid #EBEBEB;
            // box-sizing: border-box;
          }
        }

        .navTitle {
          width: 100%;

          .navTitle1 {
            float: left;
            width: 470px;

            .title_text {
              border-right: 1px solid #EBEBEB;
              border-bottom: 1px solid #EBEBEB;

              &:nth-child(4) {
                border-bottom: none;
              }

              span.span1 {
                display: inline-block;
                padding: 0 5px;
                background: rgba(54, 100, 237, 0.1);
                color: #3664ED;
                height: 24px;
                line-height: 24px;
                margin-right: 8px;
                border-radius: 4px;
              }

              span.span2 {
                display: inline-block;
                padding: 0 5px;
                background: rgba(32, 38, 204, 0.1);
                color: #2026CC;
                height: 24px;
                line-height: 24px;
                margin-right: 8px;
                border-radius: 4px;
              }
            }
          }

          .navTitle2 {
            float: left;
            width: 180px;

            .title_text {
              border-right: 1px solid #EBEBEB;
              border-bottom: 1px solid #EBEBEB;

              &:nth-child(4) {
                border-bottom: none;
              }
            }
          }

          .navTitle3 {
            float: left;
            width: 457px;
            height: 150px;
            border-bottom: 1px solid #EBEBEB;
            padding: 0 37px;
            box-sizing: border-box;

            .title_text1 {
              font-size: 16px;
              font-weight: 400;
              color: #666666;
              margin-top: 45px;
            }

            .title_text2 {
              font-size: 16px;
              font-weight: 400;
              color: #666666;
            }
          }

          .title_text {
            font-size: 16px;
            font-weight: 400;
            color: #666666;
            height: 75px;
            line-height: 75px;
            text-align: center;
            box-sizing: border-box;
          }
        }
      }
    }

    .positionBox {
      margin: 40px 0 70px 0;
      padding-bottom: 70px;
      border-bottom: 1px solid #E0E0E0;

      .title1 {
        font-size: 18px;
        font-weight: 600;
        color: #333333;
        margin-bottom: 28px;
      }

      .box {
        width: 1110px;
        .indicationImg1{
          width: 825px;
          height: 1975px;
          float: left;
        }
        .indicationImg2{
          width: 255px;
          height: 512px;
          float: right;
        }
      }
    }

    .phoneBox {
      .title1 {
        font-size: 18px;
        font-weight: 600;
        color: #333333;
      }

      .title2 {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        margin: 24px 0 16px 0;
      }

      .title3 {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
      }

      .title4 {
        font-size: 14px;
        font-weight: 400;
        color: #999999;
        margin-top: 16px;
      }
    }

    .buttomBox {
      width: 160px;
      height: 50px;

      background: #2026CC;
      border-radius: 2px;

      margin: 70px auto 0;
      a{
          width: 160px;
      height: 50px;
      display: inline-block;
      line-height: 50px;
      text-align: center;
      font-size: 18px;
      font-weight: 600;
      color: #FFFFFF;
      }
    }
  }

  &.en {
    .advertisementBox .appBox .tabBox .navTitle .navTitle1 .title_text span {
      font-size: 13px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/business/advertisement.vue